<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card>
      <div v-if="selected" class="edit-form">
        <div slot="header">
          <vs-title back>Beni Görevli Ekle</vs-title>
        </div>

        <form>
           <vs-row> 
        
                      <vs-col vs-lg="8" vs-xs="12">
                          <vs-card >
                          <vs-select
                                label="Görev Ekle"
                                placeholder="Görevler"
                                class="taskbar"
                                label-placeholder="Autocomplete"
                                autocomplete
                                v-model="eventTask"
                                >
                                <vs-select-item :key="index" :value="item" :text="item" v-for="item,index in gorevler" />
                              </vs-select>
                            <br>
                          </vs-card>
                      </vs-col>

                        <vs-col vs-lg="4" vs-xs="12">
                                   <br> <br>
                                     <vs-button color="#32bebe"  @click="gorevEkle(eventTask)">Görevli Ekle</vs-button> 

                           
                         
                      </vs-col>
                </vs-row>
        </form>

        <vs-error :errors="errors"></vs-error>

       
       
      

       

        <p>{{ message }}</p>
      </div>

      <div v-else>
        <div slot="header">
          <vs-title back>Etkinlik Seçilmedi</vs-title>
        </div>

        <p>Bir Etkinlik Seçiniz...</p>
      </div>
    </vs-card>
  </div>

</template>

<script>
  import Appeal from "@/libs/appeals/Appeal";
  import User from "@/libs/users/User";
  import { isAuthenticated, getUserFromStorage } from '@/utils/Customs'

  export default {
    name: "informations-show",
    title: "Etkinlik Görüntüle/Düzenle",

    data() {
      return {
        obj: new Appeal(),
        loading: false,
        mailList:[],
        message: '',
        gorevliler:[],
        eventTask:'',
                user: getUserFromStorage(),

        gorevler:[
            'Eğitim',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Sanatsal Çalışmalarda Jüri Üyeliği',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Sanatsal Çalışmalarda Jüri Üyeliği /	Uluslararası Yarışmalarda',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Sanatsal Çalışmalarda Jüri Üyeliği /	Ulusal Yarışmalarda',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri /	Uluslararası ve Ulusal Yarışmalarda Jüri Üyelikleri',
            'Eğitim /	Üniversitede Jüri/Komite Üyeliği /	Mimarlık Anabilim Dallarında Jüri ve Kurul Üyelikleri /	Kültür Bakanlığı Kültür ve Tabiat Varlıklarını Koruma Kurullarında En Az İki Yıllık Üyelik',
            'Eğitim /	Üniversitede Öğrenci Danışmanlığı',
            'Eğitim /	Üniversitede Ders Verme',
            'Eğitim /	Üniversite Kurul Üyeliği',
            'Eğitim /	Diğer Üniversitelerde Jüri/Komite Üyeliği',
            'Eğitim /	Diğer Üniversitelerde Öğrenci Danışmanlığı',
            'Eğitim /	Diğer Üniversitelerde Ders Verme',
            'Eğitim /	Diğer Kurum-Kuruluşlarda Kurul Üyeliği',
            'Eğitim /	Bilim Kurulu Üyeliği',
            'Eğitim /	Oturum Başkanlığı',
            'Eğitim /	Davetli Konuşmacı',

            //////////////////////////////////////////////
            'Araştırma ',
            'Araştırma /	Editörlük',
            'Araştırma /	Teknik Editör',
            'Araştırma /	Dil Editörü (Türkçe)',
            'Araştırma /	Yabancı Dil Editörü',
            'Araştırma /	Dil Editörü (Türkçe ve yabancı dil)',
            'Araştırma /	Yazım Editörü',
            'Araştırma /	Yazım ve Dil Editörü',
            'Araştırma /	Danışma Kurulu Üyesi',
            'Araştırma /	Alan Editörü',
            'Araştırma /	İstatistik Editörü',
            'Araştırma /	Mizanpaj Editörü',
            'Araştırma /	Teknik Editör',
            'Araştırma /	Dış Kaynaklı Proje',
            'Araştırma /	Bilimsel Kurul Üyeliği',
            'Araştırma /	Saha Alanı Saha Araştırmaları',
            ////////////////////////////////////////////
            'Toplumsal Katkı',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Şirket Sahibi',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Şirket Yöneticisi',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Bilirkişilik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Temsilcilik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Özel/Kamu Kuruluşlarına Danışmanlık',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Sendikal Faaliyet',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Sendikal Faaliyet /	Üyelik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	Sendikal Faaliyet /	Yöneticilik',
            'Toplumsal Katkı /	Kamu-Özel Sektör- Stk İş Birliği /	 Danışmanlık',
            'Toplumsal Katkı /	Medya',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital)',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Atölye/Uygulama Birimi Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Haber Muhabiri',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Sayfa Tasarımcı',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Yayın Koordinatörü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Haber Müdürü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Görsel Yönetmen',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Editör',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Gazete (Basılı/Dijital) /	Redaktör',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Haber Spiker',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Program Sunucusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Ses Kurgu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Ses Montaj',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Reji (Teknik Masa)',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Radyo /	Atölye Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Reji',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Yönetmen',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Resim Seçici',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Sesçi',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Işıkçı',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Kc Operatörü (Altyazı)',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Kameraman',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Teknik Yönetmen',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Playout Operatörü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları /	Televizyon /	Atölye Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları d.	Sosyal Medya',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları d.	Sosyal Medya /	Sosyal Medya Sorumlusu',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Yazı İşleri Müdürü',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Editör',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Editör Yardımcısı',
            'Toplumsal Katkı /	Medya /	Üniversite Bünyesindeki Medya Mecraları e.	Dergi /	Yayın Kurulu Üyesi',
            'Toplumsal Katkı /	Medya /	Diğer Görsel İşitsel Medya Kuruluşları',
            'Toplumsal Katkı /	Medya /	Diğer Görsel İşitsel Medya Kuruluşları /	Yapımcı/Sunucu',
            'Toplumsal Katkı /	Medya /	Diğer Görsel İşitsel Medya Kuruluşları /	Konuk - (Radyo/Tv)',
            'Toplumsal Katkı /	Medya /	Diğer Basılı Medya Kuruluşları',
            'Toplumsal Katkı /	Medya /	Diğer Basılı Medya Kuruluşları /	Dergi/Gazete Köşe Yazarı',
            'Toplumsal Katkı /	Medya /	Diğer Sosyal Medya Alanlarında',
            'Toplumsal Katkı /	Medya /	Diğer Sosyal Medya Alanlarında /	Sosyal Medya Etkileşim',
            'Toplumsal Katkı /	Turizm İlişkili Faaliyetler',
            'Toplumsal Katkı /	Turizm İlişkili Faaliyetler /	Rehberlik',
            'Toplumsal Katkı /	Turizm İlişkili Faaliyetler /	……',
            'Toplumsal Katkı /	Bankacılık ile İlişkili Faaliyetler',
            'Toplumsal Katkı /	Bankacılık ile İlişkili Faaliyetler /	Portföy',
            'Toplumsal Katkı /	Bankacılık ile İlişkili Faaliyetler /	Diğer',
            'Toplumsal Katkı /	Spor Faaliyetleri',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Hakemlik',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Antrenörlük',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Temsilcilik',
            'Toplumsal Katkı /	Spor Faaliyetleri /	Oyunculuk',
            //////////////////////////////////////////////////
            'Sanatsal Katkı',
            'Sanatsal Katkı /	Kurgulama',
            'Sanatsal Katkı /	Kurgulama /	Yönetmen',
            'Sanatsal Katkı /	Kurgulama /	Yardımcı Yönetmen',
            'Sanatsal Katkı /	Kurgulama /	Görüntü Yönetmeni',
            'Sanatsal Katkı /	Kurgulama /	Kameraman',
            'Sanatsal Katkı /	Kurgulama /	Kurgucu',
            'Sanatsal Katkı /	Kurgulama /	Sesçi',
            'Sanatsal Katkı /	Kurgulama /	Senarist',
            'Sanatsal Katkı /	Kurgulama /	Oyuncu',
            'Sanatsal Katkı /	Senaryo Yazarlığı',
            'Sanatsal Katkı /	Metin Yazarlığı',
            'Sanatsal Katkı /	Şeflik',
            'Sanatsal Katkı /	Rejisörlük',
            'Sanatsal Katkı /	Solistlik',
            'Sanatsal Katkı /	Yapımcı',
            'Sanatsal Katkı /	Oyunculuk',
            'Sanatsal Katkı /	Kameraman',
            'Sanatsal Katkı /	Görsel Efekt',
            'Sanatsal Katkı /	Ses Tasarımı',
            'Sanatsal Katkı /	Seslendirme ',
            'Sanatsal Katkı /	Yönetmen Yardımcısı',
            'Sanatsal Katkı /	Görüntü Yönetmeni',
            'Sanatsal Katkı /	Foto Muhabir',
            'Sanatsal Katkı /	Grafik Tasarımcısı',
            'Sanatsal Katkı /	Danışmanlık',
            'Sanatsal Katkı /	Danışmanlık /	Öğrenci Çalışmaları',

       
      ],
        languages2:[
        {text: 'Türkçe', value: 'Türkçe'},
        {text: 'İngilizce', value: 'İngilizce'},
        {text: 'Almanca', value: 'Almanca'},
        {text: 'İtalyanca', value: 'İtalyanca'},
        {text: 'İspanyolca', value: 'İspanyolca'},
        {text: 'Fransızca', value: 'Fransızca'},
        {text: 'Arapça', value: 'Arapça'},
        
      ],
      };
    },

    computed: {
      saved() {
        return this.obj.saved
      },

      deleted() {
        return this.obj.deleted
      },

      submitted() {
        return this.obj.form.submitted
      },

      contaminated() {
        return this.obj.form.errorDetected
      },

      errors() {
        return this.obj.form.errors
      },

      selected() {
        return this.obj.selected
      },
    },

    watch: {
      contaminated(val) {
        this.loading = false
      },

      submitted(val) {
        if(val)
          this.loading = false
      },

      saved(val) {
        if(val)
          this.message = 'Etkinlik Başarıyla Güncellendi!';
      },

      deleted(val) {
        if(val)
          this.$router.go(-1) // back
      },
    },

    methods: {
      gorevEkle(gorevdata){

     
      
        this.gorevliler.push({ekleyen: this.user.adKullaniciAdi, kiminAdina: this.user.adKullaniciAdi, gorev: gorevdata});





        this.obj.columns=this.selected
      
        this.obj.columns.gorevliler=this.selected.gorevliler.concat(this.gorevliler); 

         this.obj.update(this.selected.id, true)
         const formData = new FormData();
                 this.mailList.push(selected.createdByMail)
                  
                   
                formData.append('email', this.user.adi+' '+this.user.soyadi+' isimli kullanıcı, '+this.selected.eventName +' etkinliğinize görevli olarak eklendi.')

                   formData.append('kime',this.mailList )

              axios.post('https://eys.hacibayram.edu.tr:8081/api/email-deneme', formData, {
              }).then((res) => {
                console.log(res)
              })
    },
      get(id) {
        this.obj.get(id, true);
      },

      updatePublished(status) {
        this.obj.columns.published = status
        return this.update()
      },

      update() {
        this.loading = true
        this.obj.update(this.selected.id, true)
      },

      deleteItem() {
        this.loading = true
        this.obj.delete(this.selected.id)
      }
    },

    mounted() {
       this.message = '';
      this.get(this.$route.params.id);
    }
  };
</script>

<style>
  .edit-form {
    max-width: 70%;
    margin: auto;
  }
</style>